<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xiii"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td class="tdleft">AB</td>
<td class="tdleft">Anchor Bible</td>
</tr>
<tr>
<td class="tdleft">ABD</td>
<td class="tdleft">Anchor Bible Dictionary</td>
</tr>
<tr>
<td class="tdleft">AGJU</td>
<td class="tdleft">Arbeiten zur Geschichte des antiken Judentums und des Urchristentums</td>
</tr>
<tr>
<td class="tdleft"><i>AJP</i></td>
<td class="tdleft"><i>American Journal of Philology</i></td>
</tr>
<tr>
<td class="tdleft">ANF</td>
<td class="tdleft">Ante-Nicene Fathers</td>
</tr>
<tr>
<td class="tdleft">ANTC</td>
<td class="tdleft">Abingdon New Testament Commentaries</td>
</tr>
<tr>
<td class="tdleft">BDAG</td>
<td class="tdleft">Danker, Frederick W., Walter Bauer, William F. Arndt, and F. Wilbur Gingrich. <i>Greek-English of the New Testament and Other Early Christian Literature</i>. 3rd ed. Chicago: University of Chicago Press, 2000 (Danker-Bauer-Arndt-Gingrich).</td>
</tr>
<tr>
<td class="tdleft">BDF</td>
<td class="tdleft">Blass, Friedrich, Albert Debrunner, and Robert W. Funk. <i>A Greek Grammar of the New Testament and Other Early Christian Literature</i>. Chicago: University of Chicago Press, 1961.</td>
</tr>
<tr>
<td class="tdleft"><i>Bib</i></td>
<td class="tdleft"><i>Biblica</i></td>
</tr>
<tr>
<td class="tdleft"><i>BJRL</i></td>
<td class="tdleft"><i>Bulletin of the John Rylands University Library of Manchester</i></td>
</tr>
<tr>
<td class="tdleft"><i>BR</i></td>
<td class="tdleft"><i>Biblical Research</i></td>
</tr>
<tr>
<td class="tdleft">BZNW</td>
<td class="tdleft">Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</td>
</tr>
<tr>
<td class="tdleft"><i>CBQ</i></td>
<td class="tdleft"><i>Catholic Biblical Quarterly</i></td>
</tr>
<tr>
<td class="tdleft">CEB</td>
<td class="tdleft">Common English Bible</td>
</tr>
<tr>
<td class="tdleft">CGTC</td>
<td class="tdleft">Cambridge Greek Testament Commentary</td>
</tr>
<tr>
<td class="tdleft"><i>CurBR</i></td>
<td class="tdleft"><i>Currents in Biblical Research</i></td>
</tr>
<tr>
<td class="tdleft"><i>DNTB</i></td>
<td class="tdleft"><i>Dictionary of New Testament Background</i>. Edited by Craig A. Evans and Stanley E. Porter. Downers Grove, IL: InterVarsity Press, 2000.</td>
</tr>
<tr>
<td class="tdleft"><i>DPL</i></td>
<td class="tdleft"><i>Dictionary of Paul and His Letters</i>. Edited by Gerald F. Hawthorne and Ralph P. Martin. Downers Grove, IL: InterVarsity Press, 1993.</td>
</tr>
<tr>
<td class="tdleft"><a id="page_xiv"><i>EDNT</i></a></td>
<td class="tdleft"><i>Exegetical Dictionary of the New Testament</i>. Edited by Horst Balz and Gerhard Schneider. ET. 3 vols. Grand Rapids: Eerdmans, 1990–1993.</td>
</tr>
<tr>
<td class="tdleft">EFN</td>
<td class="tdleft">Estudios de filología neotestamentaria</td>
</tr>
<tr>
<td class="tdleft">EKKNT</td>
<td class="tdleft">Evangelische-katholischer Kommentar zum Neuen Testament</td>
</tr>
<tr>
<td class="tdleft"><i>EvQ</i></td>
<td class="tdleft"><i>Evangelical Quarterly</i></td>
</tr>
<tr>
<td class="tdleft"><i>ExpTim</i></td>
<td class="tdleft"><i>Expository Times</i></td>
</tr>
<tr>
<td class="tdleft">FC</td>
<td class="tdleft">Fathers of the Church</td>
</tr>
<tr>
<td class="tdleft">FF</td>
<td class="tdleft">Foundation and Facets</td>
</tr>
<tr>
<td class="tdleft">HNT</td>
<td class="tdleft">Handbuch zum Neuen Testament</td>
</tr>
<tr>
<td class="tdleft"><i>HTR</i></td>
<td class="tdleft"><i>Harvard Theological Review</i></td>
</tr>
<tr>
<td class="tdleft">HUT</td>
<td class="tdleft">Hermeneutische Untersuchungen zur Theologie</td>
</tr>
<tr>
<td class="tdleft">ICC</td>
<td class="tdleft">International Critical Commentary</td>
</tr>
<tr>
<td class="tdleft"><i>JBL</i></td>
<td class="tdleft"><i>Journal of Biblical Literature</i></td>
</tr>
<tr>
<td class="tdleft"><i>JEH</i></td>
<td class="tdleft"><i>Journal of Ecclesiastical History</i></td>
</tr>
<tr>
<td class="tdleft"><i>JSNT</i></td>
<td class="tdleft"><i>Journal for the Study of the New Testament</i></td>
</tr>
<tr>
<td class="tdleft">JSNTSup</td>
<td class="tdleft">Journal for the Study of the New Testament Supplement Series</td>
</tr>
<tr>
<td class="tdleft"><i>JSSR</i></td>
<td class="tdleft"><i>Journal for the Scientific Study of Religion</i></td>
</tr>
<tr>
<td class="tdleft">LCL</td>
<td class="tdleft">Loeb Classical Library</td>
</tr>
<tr>
<td class="tdleft">LEC</td>
<td class="tdleft">Library of Early Christianity</td>
</tr>
<tr>
<td class="tdleft">L&amp;N</td>
<td class="tdleft">Louw, Johannes P., and Eugene A. Nida, eds. <i>Greek-English Lexicon of the New Testament: Based on Semantic Domains.</i> 2nd ed. New York: United Bible Societies, 1989.</td>
</tr>
<tr>
<td class="tdleft">LNTS</td>
<td class="tdleft">The Library of New Testament Studies</td>
</tr>
<tr>
<td class="tdleft">NCB</td>
<td class="tdleft">New Century Bible</td>
</tr>
<tr>
<td class="tdleft"><i>NewDocs</i></td>
<td class="tdleft"><i>New Documents Illustrating Early Christianity</i>. Edited by Greg H. R. Horsley and Stephen Llewelyn. North Ryde, NSW: The Ancient History Documentary Research Centre, Macquarie University, 1981–.</td>
</tr>
<tr>
<td class="tdleft">NICNT</td>
<td class="tdleft">New International Commentary on the New Testament</td>
</tr>
<tr>
<td class="tdleft"><i>NIDNTTE</i></td>
<td class="tdleft"><i>New International Dictionary of New Testament Theology and Exegesis</i>. Edited by Moisés Silva. 5 vols. Grand Rapids: Zondervan, 2014.</td>
</tr>
<tr>
<td class="tdleft">NIGTC</td>
<td class="tdleft">New International Greek Testament Commentary</td>
</tr>
<tr>
<td class="tdleft">NIV</td>
<td class="tdleft">New International Version</td>
</tr>
<tr>
<td class="tdleft"><i>NovT</i></td>
<td class="tdleft"><i>Novum Testamentum</i></td>
</tr>
<tr>
<td class="tdleft">NPNF1</td>
<td class="tdleft"><i>Nicene and Post-Nicene Fathers</i>, Series 1</td>
</tr>
<tr>
<td class="tdleft">NTOA</td>
<td class="tdleft">Novum Testamentum et Orbis Antiquus</td>
</tr>
<tr>
<td class="tdleft"><i>NTS</i></td>
<td class="tdleft"><i>New Testament Studies</i></td>
</tr>
<tr>
<td class="tdleft">NTTS</td>
<td class="tdleft">New Testament Tools and Studies</td>
</tr>
<tr>
<td class="tdleft">ÖTK</td>
<td class="tdleft">Ökumenischer Taschenbuch-Kommentar</td>
</tr>
<tr>
<td class="tdleft">P.Oxy.</td>
<td class="tdleft">Oxyrhynchus Papyri</td>
</tr>
<tr>
<td class="tdleft"><a id="page_xv"><i>PRSt</i></a></td>
<td class="tdleft"><i>Perspectives in Religious Studies</i></td>
</tr>
<tr>
<td class="tdleft"><i>R&amp;T</i></td>
<td class="tdleft"><i>Religion and Theology</i></td>
</tr>
<tr>
<td class="tdleft"><i>ResQ</i></td>
<td class="tdleft"><i>Restoration Quarterly</i></td>
</tr>
<tr>
<td class="tdleft">SBLDS</td>
<td class="tdleft">Society of Biblical Literature Dissertation Series</td>
</tr>
<tr>
<td class="tdleft"><i>SecCent</i></td>
<td class="tdleft"><i>Second Century</i></td>
</tr>
<tr>
<td class="tdleft">SP</td>
<td class="tdleft">Sacra Pagina</td>
</tr>
<tr>
<td class="tdleft"><i>TJ</i></td>
<td class="tdleft"><i>Trinity Journal</i></td>
</tr>
<tr>
<td class="tdleft"><i>TLNT</i></td>
<td class="tdleft"><i>Theological Lexicon of the New Testament</i>. C. Spicq. Translated and edited by J. D. Ernest. 3 vols. Peabody, MA: Hendrickson, 1994.</td>
</tr>
<tr>
<td class="tdleft">TNTC</td>
<td class="tdleft">Tyndale New Testament Commentaries</td>
</tr>
<tr>
<td class="tdleft"><i>TynBul</i></td>
<td class="tdleft"><i>Tyndale Bulletin</i></td>
</tr>
<tr>
<td class="tdleft"><i>USQR</i></td>
<td class="tdleft"><i>Union Seminary Quarterly Review</i></td>
</tr>
<tr>
<td class="tdleft">WMANT</td>
<td class="tdleft">Wissenschaftliche Monographien zum Alten und Neuen Testament</td>
</tr>
<tr>
<td class="tdleft">WUNT</td>
<td class="tdleft">Wissenschaftliche Untersuchungen zum Neuen Testament</td>
</tr>
<tr>
<td class="tdleft"><i>ZNW</i></td>
<td class="tdleft"><i>Zeitschrift für die Neutestamentliche Wissenschaft und die Kunde der älteren Kirche</i></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?5caf6e4a